import type { BoundaryPoint } from "./geo";
import {
  canRedoHistory,
  canUndoHistory,
  createUndoHistoryReducer,
  type UndoHistoryState,
} from "./undoHistory";

export interface BoundaryHistorySnapshot {
  isClosed: boolean;
  points: BoundaryPoint[];
}

export type BoundaryHistoryState = UndoHistoryState<BoundaryHistorySnapshot>;

export const canUndoBoundaryHistory = canUndoHistory<BoundaryHistorySnapshot>;

export const canRedoBoundaryHistory = canRedoHistory<BoundaryHistorySnapshot>;

export const boundaryHistoryReducer =
  createUndoHistoryReducer<BoundaryHistorySnapshot>();
